import { render } from "./ManageDepotProductsModal.html?vue&type=template&id=681f5b1b&scoped=true"
import script from "./ManageDepotProductsModal.js?vue&type=script&lang=js"
export * from "./ManageDepotProductsModal.js?vue&type=script&lang=js"

import "./ManageDepotProductsModal.css?vue&type=style&index=0&id=681f5b1b&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681f5b1b"]])

export default __exports__